/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-6': {
    width: 52,
    height: 38,
    viewBox: '0 0 52 38',
    data: '<path pid="0" class="st0" d="M48.1 33.3c-.1.2-.4 1-1.4 1H4.6c-1 0-1.3-.8-1.4-1-.1-.2-.2-1.1.6-1.6l6.9-3.5 1.8 3.4 6.7-3.6-1.7-3.3 8.1-4.1 8 4.1-1.7 3.3 6.7 3.6 1.8-3.4 7 3.6c.9.4.8 1.3.7 1.5M12.8 22.5l2.2 4.2-1.2.6-2.2-4.2 1.2-.6zm25.6 0l1.2.6-2.2 4.2-1.2-.6 2.2-4.2zM49 29l-7.1-3.6 1.9-3.6-6.8-3.6-1.9 3.7-7.9-4v-3.1c3.4-.7 5.9-3.7 5.9-7.3 0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5h3.1c0-2.4 1.9-4.3 4.3-4.3C28 3.1 30 5.1 30 7.5s-1.9 4.3-4.3 4.3h-1.6v6l-8 4.1-2-3.7-6.7 3.6 1.9 3.6-7 3.6h-.1C.4 30.1-.4 32.1.1 34.1c.5 2 2.3 3.4 4.4 3.4h42.2c2.1 0 3.8-1.3 4.4-3.4.6-2-.3-4-2.1-5.1"/>'
  }
})
